import { render, staticRenderFns } from "./inAppImage.vue?vue&type=template&id=23dd621f&scoped=true"
import script from "./inAppImage.vue?vue&type=script&lang=js"
export * from "./inAppImage.vue?vue&type=script&lang=js"
import style0 from "./inAppImage.vue?vue&type=style&index=0&id=23dd621f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd621f",
  null
  
)

export default component.exports